// src/services/bankDetails.ts

export interface BankDetail {
  bankName: string;
  accountNumber: string;
  accountName: string;
  branch?: string;
  swiftCode?: string;
  routingNumber?: string;
  currency: string;
  instructions?: string;
}

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://sparklinggems.shop/api'
  : 'http://localhost/sparkling-gems-backend-php/api';

export const fetchBankDetails = async (): Promise<BankDetail[]> => {
  try {
    console.log('📋 Fetching bank details from:', `${API_BASE_URL}/bank-details/get.php`);
    
    const response = await fetch(`${API_BASE_URL}/bank-details/get.php`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return [];
    }

    const text = await response.text();
    console.log('Raw response:', text.substring(0, 200) + '...'); // Log first 200 chars
    
    // Try to parse JSON
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error('Failed to parse JSON. Response starts with:', text.substring(0, 100));
      return [];
    }
    
    console.log('✅ Bank details response:', data);

    if (data.success && Array.isArray(data.banks)) {
      return data.banks;
    } else {
      console.error('❌ Failed to fetch bank details:', data.error || 'Unknown error');
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching bank details:', error);
    return [];
  }
};

export const getDefaultBank = (banks: BankDetail[]): BankDetail | null => {
  if (!banks || banks.length === 0) return null;
  return banks[0];
};

export const formatAccountNumber = (accountNumber: string): string => {
  if (!accountNumber) return '';
  if (accountNumber.length <= 8) return accountNumber;
  
  const visibleStart = accountNumber.slice(0, 4);
  const visibleEnd = accountNumber.slice(-4);
  const masked = '•'.repeat(Math.min(accountNumber.length - 8, 4));
  
  return `${visibleStart}${masked}${visibleEnd}`;
};